import { useRef } from "react";
import makeStyles from "@mui/styles/makeStyles";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import ApplicationBar, {
  toolbarHeight,
} from "./../../Components/ApplicationBar";

import MainTabs from "../../Components/MainTabs";
import Footer from "../../Components/Footer";
import { useReactToPrint } from "react-to-print";
import { Box } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  content: {
    flexGrow: 1,
    overflow: "auto",
    marginTop: toolbarHeight,
    marginBottom: toolbarHeight,
    height: `calc(100vh - ${toolbarHeight * 2}px)`,
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(2),
  },
  mainPaper: {
    // padding: theme.spacing(2),
    display: "flex",
    height: `calc(100vh - ${toolbarHeight * 2 + 150}px)`,
    overflow: "scroll",
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
  },
  box: {
    padding: theme.spacing(2),
  },
  actionsWrapper: {
    display: "flex",
    justifyContent: "space-between",
  },
  actionButton: {
    "&:hover": {
      backgroundColor: theme.palette.gif.blue.hover,
    },
    color: theme.palette.gif.blue.color,
    backgroundColor: theme.palette.gif.blue.background,
  },
}));

export default function MainLayout({ children, navigation, baseurl }) {
  const classes = useStyles();
  const printRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    
  });
  const marginTop = "15mm";
  const marginRight ="10mm";
  const marginBottom = "15mm";
  const marginLeft ="10mm";

  const getPageMargins = () => {
    return `@page { margin: ${marginTop} ${marginRight} ${marginBottom} ${marginLeft} !important; size: 210mm 297mm; }`;
  };
  return (
    <div className={classes.root}>
      <CssBaseline />
      <ApplicationBar handlePrint={handlePrint} />
      <main className={classes.content}>
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <MainTabs baseurl={baseurl} />
            </Grid>
            <Grid item xs={12}>
              <Paper className={classes.mainPaper}>
                <Box className={`${classes.box} ${classes.printContainer}`} ref={printRef}>
                  <style>{getPageMargins()}</style>
                  {children}
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </main>
      <Footer />
    </div>
  );
}
